import { render, staticRenderFns } from "./BackgroundContent.vue?vue&type=template&id=62672b6f&scoped=true&"
import script from "./BackgroundContent.vue?vue&type=script&lang=ts&"
export * from "./BackgroundContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62672b6f",
  null
  
)

export default component.exports